module.exports = __webpack_public_path__ + "img/logo.fa4b44ca.png";